import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private injector: Injector, private ngZone: NgZone) {}

  handleError(error: any): void {
    // S'assurer que l'exécution se fait dans la NgZone pour Angular
    this.ngZone.run(() => {
      console.error('Erreur interceptée par le GlobalErrorHandler:', error);

      const message = error?.message ? error.message : error?.toString();

      // On affiche une notification générique à l'utilisateur
    //   Swal.fire({
    //     title: 'Erreur inattendue',
    //     text: 'Une erreur technique est survenue. L\'équipe technique a été notifiée.',
    //     icon: 'error',
    //     toast: true,
    //     position: 'top-end',
    //     width: '800px', // Vraiment plus long maintenant
    //     showConfirmButton: false,
    //     timer: 5000,
    //     timerProgressBar: true
    //   });
    });
  }
}
